import { default as config, default as env } from '../../../../../env'

const timeout = (ms: number, promise: Promise<Response>): Promise<Response> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error('timeout'))
    }, ms)

    promise.then(resolve, reject)
  })
}

const fetchWithCredentials = (input: RequestInfo, init?: RequestInit): Promise<Response> => {
  return fetch(input, {
    ...init,
    ...withCredentials,
  })
}

const withCredentials: RequestInit = { credentials: 'include' }

const fetchWithTimeout = (input: RequestInfo, init?: RequestInit): Promise<Response> => {
  return timeout(config.timeout || 45000, fetchWithCredentials(input, init))
}

type FetchOptions = {
  path: string
  body?: any // eslint-disable-line @typescript-eslint/no-explicit-any
  method?: 'POST' | 'GET' | 'PUT' | 'DELETE'
  omitHostname?: boolean
}

export const makeApiCall = ({
  path,
  body,
  method,
  omitHostname,
}: FetchOptions): Promise<Response> => {
  const url = omitHostname ? path : env.hostname + path
  const headers = body ? { 'Content-Type': 'application/json' } : undefined

  return fetchWithTimeout(url, {
    method,
    body: body ? JSON.stringify(body) : null,
    headers,
  })
}
